var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("このサイトについて")]),_c('p',[_vm._v(" 公共のスポーツ施設の休日の空き情報を分かりやすく発信しています。 "),_c('br'),_vm._v("空きが出たらtwitterでつぶやいています。 ")])])}]

export { render, staticRenderFns }